import classNames from 'classnames'
import React from 'react'
import styles from './Illustration.module.scss'
import type { IllustrationProps } from './types'
import { IllustrationSize } from './types'

const Illustration: React.FC<IllustrationProps> = ({
  className,
  size = IllustrationSize.medium,
  src,
  alt,
  ariaLabel,
  role,
  ...props
}) => {
  return (
    <div className={classNames(styles['pintxo-illustration'], className)} data-size={size}>
      <img src={src} alt={alt} aria-label={ariaLabel} role={role} {...props} />
    </div>
  )
}

export default Illustration
